import {
  IonAccordion,
  IonAccordionGroup,
  IonIcon,
  IonItem,
} from "@ionic/react";
import {
  chevronDownOutline,
  closeSharp,
  colorFill,
  colorFillOutline,
} from "ionicons/icons";
import { v4 } from "uuid";
import CorrectionAnswer from "./CorrectionAnswer";
import { IQuestion } from "./Quizz";

interface ICorrectionProps {
  questions: IQuestion[];
  userAnwser: Map<string, boolean>;
}

const Correction: React.FC<ICorrectionProps> = ({ questions, userAnwser }) => {

  return (
    <>
      <IonAccordionGroup>
        {questions.map((question, indexQ) => (
          <IonAccordion key={v4()} toggleIcon="">
            <IonItem
              slot="header"
              color="white"
              style={
                indexQ === 0
                  ? {
                      borderTop: "#eb1d5f 4px solid",
                      borderLeft: "#eb1d5f 2px solid",
                      borderRight: "#eb1d5f 2px solid",
                      borderBottom: "#eb1d5f 2px solid",
                    }
                  : { border: "#eb1d5f 2px solid" }
              }
            >
              {question.question}
              <IonIcon icon={chevronDownOutline} slot="end" />
            </IonItem>
            <div slot="content">
              <CorrectionAnswer
                questionIndex={indexQ}
                userAnswers={userAnwser}
                question={question}
              />
            </div>
          </IonAccordion>
        ))}
      </IonAccordionGroup>
    </>
  );
};

export default Correction;
